"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuLinks = exports.SecondaryLinks = exports.PrimaryLinks = void 0;
var react_1 = __importDefault(require("react"));
var find_1 = __importDefault(require("lodash/find"));
var PrimaryLinks;
(function (PrimaryLinks) {
    PrimaryLinks["Home"] = "HOME";
    PrimaryLinks["MyTeam"] = "MY_TEAM";
    PrimaryLinks["Initiatives"] = "INITIATIVES";
    PrimaryLinks["Programs"] = "PROGRAMS";
    PrimaryLinks["OneToOnes"] = "ALIGN";
    PrimaryLinks["Yearbook"] = "YB";
    PrimaryLinks["Anniversaries"] = "ANNIVERSARIES";
    PrimaryLinks["Wellbeing"] = "WELLBEING";
})(PrimaryLinks = exports.PrimaryLinks || (exports.PrimaryLinks = {}));
var SecondaryLinks;
(function (SecondaryLinks) {
    SecondaryLinks["Admin"] = "ADMIN";
})(SecondaryLinks = exports.SecondaryLinks || (exports.SecondaryLinks = {}));
var MenuLinks;
(function (MenuLinks) {
    MenuLinks["Profile"] = "PROFILE";
    MenuLinks["Settings"] = "SETTINGS";
    MenuLinks["RewardCode"] = "REWARD_CODE";
    MenuLinks["ShippingAddress"] = "SHIPPING_ADDRESS";
    MenuLinks["MyHistory"] = "MY_HISTORY";
    MenuLinks["Logout"] = "LOGOUT";
})(MenuLinks = exports.MenuLinks || (exports.MenuLinks = {}));
var useLayoutLinks = function (layout) {
    var _a, _b;
    var links = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.cultureCloud) === null || _a === void 0 ? void 0 : _a.ccHeader) === null || _b === void 0 ? void 0 : _b.links;
    var result = react_1.default.useMemo(function () {
        var base = {
            primaryLinks: [],
            secondaryLinks: [],
            menuLinks: [],
        };
        if (links) {
            var primaryKeys = Object.values(PrimaryLinks);
            var secondaryKeys = Object.values(SecondaryLinks);
            var menuKeys = Object.values(MenuLinks);
            primaryKeys.forEach(function (key) {
                var link = (0, find_1.default)(links, function (link) { return link.id === key; });
                if (link)
                    base.primaryLinks.push(link);
            });
            secondaryKeys.forEach(function (key) {
                var link = (0, find_1.default)(links, function (link) { return link.id === key; });
                if (link)
                    base.secondaryLinks.push(link);
            });
            menuKeys.forEach(function (key) {
                var link = (0, find_1.default)(links, function (link) { return link.id === key; });
                if (link === null || link === void 0 ? void 0 : link.url)
                    base.menuLinks.push(link);
            });
        }
        return base;
    }, [links]);
    return result;
};
exports.default = useLayoutLinks;
//# sourceMappingURL=useLayoutLinks.js.map